<div *ngIf="isMobile && isLoggedIn()" class="hide-on-desktop">
  <div class="mobile-tabs">
    <!-- Home (horizontal layout) -->
    <a routerLink="/dashboard/home" routerLinkActive="active-tab" class="tab home-tab" [routerLinkActiveOptions]="{ exact: true }">
      <span class="material-symbols-outlined icon">home</span>
      <span class="label">Home</span>
    </a>

    <!-- In-play -->
    <a routerLink="/dashboard/cricket" routerLinkActive="active-tab" class="tab home-tab">
      <span class="material-symbols-outlined icon">play_circle</span>
      <span class="label">Cricket</span>
    </a>

    <!-- Casino -->
    <a routerLink="/dashboard/livecasino" routerLinkActive="active-tab" class="tab home-tab">
      <span class="material-symbols-outlined icon">token</span>
      <span class="label">Casino</span>
    </a>

    <!-- Promotion -->
    <a routerLink="/dashboard/bonus" routerLinkActive="active-tab" class="tab home-tab">
      <span class="material-symbols-outlined icon">celebration</span>
      <span class="label">Promotion</span>
    </a>
  </div>
</div>



<!-- <div *ngIf="!shouldRun">Please open on Stackblitz to see result</div> -->


<!-- Copyright 2023 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license -->

<!--
<mat-drawer-container class="example-container" autosize>
    <mat-drawer #drawer class="example-sidenav" mode="over">
        <p>Auto-resizing sidenav</p>
        <p *ngIf="showFiller">Lorem, ipsum dolor sit amet consectetur.</p>
        <button (click)="showFiller = !showFiller" mat-raised-button>
          Toggle extra text
        </button>
      </mat-drawer>


</mat-drawer-container> -->

